import request from './request';
export const GAME_ROLE_BIND = 'amp2.RoleSrv/BindRole';
export const GAME_ROLE_UN_BIND = 'amp2.RoleSrv/UnBindRole';
export const GAME_GET_BIND_ROLE = 'amp2.RoleSrv/GetBindRole';

export default class Game {
  static bindRole(params, scene) {
    return request.post(GAME_ROLE_BIND, { ...params, scene });
  }
  static unBindRole(params, scene) {
    return request.post(GAME_ROLE_UN_BIND, { ...params, scene });
  }
  static async getBindRole(params, scene) {
    try {
      const data = await request.post(GAME_GET_BIND_ROLE, { ...params, scene });
      return data.roles[0];
    } catch (error) {
      if (error.code === 404) {
        // 这里是找不到角色，正常错误可忽略
        return null;
      }
      throw error;
    }
  }
  /**
   *
   * @param {Object} params 查询角色所需参数
   * @param {String} scene 限定的场景维度
   * @returns
   */
  static async getBindRoleList(params, scene) {
    try {
      const data = await request.post(GAME_GET_BIND_ROLE, { ...params, scene });
      return data.roles;
    } catch (error) {
      if (error.code === 404) {
        // 这里是找不到角色，正常错误可忽略
        return [];
      }
      throw error;
    }
  }
}
